export class GetHelpContent {
  static readonly type = "[HelpContent] Get help content";
}
